<template>
  <div
    v-if="pairsWith.length"
    class="mb-lgp">
    <h6 class="mb-xs">
      Pairs with
    </h6>
    <HorizontalScroll>
      <PreviewImageButton
        v-for="(styleColorId, index) in pairsWith"
        :key="styleColorId"
        class="me-md"
        size="small"
        :src="getImageSource(styleColorId)"
        :alt="getAltText(styleColorId)"
        @click="handleClick(styleColorId, index)"/>
    </HorizontalScroll>
  </div>
</template>

<script setup>
import HorizontalScroll from '@shared/components/ADORN/HorizontalScroll.vue'
import PreviewImageButton from '@shared/components/ADORN/PreviewImageButton.vue'
import useStyleColor from '@shared/composables/styleColor.js'
import { useClosetStore } from '@shared/stores/closet.js'
import { useFlyouts } from '@/composables/flyouts.js'
import { storeToRefs } from 'pinia'

const props = defineProps({
  styleColor: {
    type: Object,
    required: true
  }
})

const { styleColorsMap } = storeToRefs(useClosetStore())
const { pairsWith } = useStyleColor(() => props.styleColor)
const flyouts = useFlyouts()

function getImageSource (styleColorId) {
  const styleColor = styleColorsMap.value[styleColorId]
  if (!styleColor) return null
  return styleColor.images?.front?.url ?? null
}

function getAltText (styleColorId) {
  const styleColor = styleColorsMap.value[styleColorId]
  if (!styleColor) return ''
  const brand = styleColor.style?.brand || ''
  const name = styleColor.style?.name || ''
  return `${brand} ${name}`.trim()
}

function getStyleColorSource (styleColorId, index) {
  return {
    sourceId: props.styleColor.id,
    sourceType: 'pairswith',
    sourceName: null,
    sourceLocation: null,
    sourceSlot: null,
    sourcePosition: index + 1
  }
}

function handleClick (styleColorId, index) {
  const styleColor = styleColorsMap.value[styleColorId]
  if (!styleColor) return

  const source = getStyleColorSource(styleColorId, index)
  flyouts.openClosetDetailFlyout(styleColor, source, index)
}
</script>
